import { ToastMessage } from '@cokitchen/cokitchen-components';
import SingleBottomNav from 'components/base/single-bottom-nav';
import WorkingHours from 'components/working-hours';
import useEditShopContext from 'contexts/shop.context';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';

type Props = {
  onEditComplete: () => void;
};
const EditShopOpeningTime = ({ onEditComplete }: Props) => {
  const { shopDetails, setShopDetails } = useEditShopContext();
  const { brand_working_hours } = shopDetails;
  const [workingHours, setWorkingHours] = useState(brand_working_hours);

  const [loading, setLoading] = useState(false);

  const { shop_id } = useParams();

  const handleUpdateShop = async () => {
    setLoading(true);
    const payload = {
      opening_hours: workingHours?.map((data: any) => ({
        ...data,
        day: data.name,
        open_time: data.opening_time.toString(),
        close_time: data.closing_time.toString()
      }))
    };
    try {
      await apiService.put(`shops/${{ shop_id }}`, { data: payload });

      onEditComplete();
      toast(<ToastMessage type='success' message={`Shop updated successfully`} />);
    } catch {
      toast(<ToastMessage type='error' message={`There was a problem updating shop `} />);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const updatedBrandWorkingHours = brand_working_hours?.map((brandHour: any) => {
      const matchingWorkHour = workingHours.find(
        (workHour: any) => workHour.name === brandHour.name
      );

      if (matchingWorkHour) {
        return {
          ...brandHour,
          opening_time: matchingWorkHour.opening_time,
          closing_time: matchingWorkHour.closing_time,
          active: matchingWorkHour.active
        };
      }

      return brandHour;
    });

    setShopDetails({
      ...shopDetails,
      brand_working_hours: updatedBrandWorkingHours
    });
  }, [workingHours]);

  return (
    <section>
      <WorkingHours data={workingHours} setData={setWorkingHours} />
      <SingleBottomNav
        loading={loading}
        onConfirm={handleUpdateShop}
        backBtndisabled
        btnDisabled={loading}
      />
    </section>
  );
};

export default EditShopOpeningTime;
